export default [
    "HTT",
    "HTTF",
    "HTTF_7N7JS",
    "HTTF_7N8JS",

    "PFTT",
    "PFTT_7N6JS",
    "PFTT_8N7JS",

    "PFPTT",
    "PFPTTF",
    "PFPTTF_7N7JS",
    "PFPTTF_7N8JS",
    
    "PFTTF",
    "PFTTF_7N7JS",
    "PFTTF_7N8JS",

    "PFTTNL",
    "PFTTNL_7N7JS",
    "PFTTNL_7N8JS",
    "PFPTTNL",
    "PFPTTNL_7N7JS",
    "PFPTTNL_7N8JS",
];